<template>
 <div>
   <p class="text-xs-center" v-if="error">Podany link aktywacyjny nie istnieje.</p>
</div>
</template>

<script>
import iziToast from 'izitoast'
import * as types from '@/store/mutation-types'
import {accountConfirmEmail} from './api'

export default {
  data () {
    return {
      error: false
    }
  },
  mounted () {
    accountConfirmEmail(this.token).then((data) => {
      iziToast.show({
        message: 'Konto zostało aktywowane',
        color: 'green'
      })
      this.$store.dispatch(types.AUTH_TOKEN, data.token).then(() => {
        this.$router.push({name: 'app'})
      })
    }).catch((data) => {
      if (data.response.status === 404) {
        this.error = true
      }
    })
  },
  computed: {
    token () {
      return this.$route.params.token
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/auth/AccountConfirmEmail.vue